import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-item/paper-icon-item.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/iron-icon/iron-icon.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
/**
 * A list item with an optional url and icon
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarListItem extends PolymerElement {
  static get template() {
    return html`
    <style include="cbar-shared-styles">
      :host {
        display: block;
      }
      [hidden] {
          display: none;
      }
      a {
          text-decoration: none;
          color: inherit;
          background: inherit;
          outline: none;
          pointer-events: auto;
      }
      paper-icon-item{
            --paper-item-icon: {
                flex-shrink: 0;
            }
      }
    </style>

    <a href="[[url]]">
      <template is="dom-if" if="[[icon]]">
        <paper-icon-item>
          <iron-icon icon="[[icon]]" slot="item-icon"></iron-icon>

          <span>[[itemTitle]]</span>
        </paper-icon-item>
      </template>

      <template is="dom-if" if="[[!icon]]">
        <paper-item>[[itemTitle]]</paper-item>
      </template>
    </a>
`;
  }

  static get is() {
      return 'cbar-list-item';
  }

  static get properties() {
      return {
          /**
           * The icon to display
           */
          icon: {
              type: String,
              value: false,
          },

          /**
           * The text to display for this item in the drawer
           */
          itemTitle: String,

          /**
           * The url to redirect to when this item is clicked
           */
          url: {
              type: String,
              value: 'javascript:void(null)',
          },
      };
  }
}

window.customElements.define(CbarListItem.is, CbarListItem);
